enum Paths {
  Root = "/consent-solutions",
  Create = "create",
  Edit = ":id",
}

export default Paths;
